
import { Grid, Container,} from '@mui/material';
// import { useTheme } from '@mui/material/styles';

import useSettings from '../../hooks/useSettings';

import Page from '../../components/Page';

import AllHiddenApplicationsTable from '../../sections/tables/AllHiddenApplicationsTable';



// ----------------------------------------------------------------------

export default function AllHiddenApplications() {
  const { themeStretch } = useSettings();
//   const theme = useTheme();





  return (
    <Page title="Dashboard Hidden Applications">
      <Container maxWidth={themeStretch ? false : 'xl'}>
    
         
       
        <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <AllHiddenApplicationsTable />
          </Grid>
          </Grid>
      </Container>
    </Page>
  );
}
